import template from './denomination.html';
import controller from './denomination.controller';
import './denomination.scss';

let denominationComponent = {
  restrict: 'E',
  bindings: {
  	acl: '=',
    hasACL:'='
  },
  template,
  controller
};

export default denominationComponent;


// WEBPACK FOOTER //
// ./client/app/components/tnt_control/component/denomination/denomination.component.js